// DOM lookup shared by the screen controllers. Call after DOMContentLoaded.
export const $ = id => document.getElementById(id);
